__turbopack_context__.v({
  "body": "index-module-scss-module__jymB6W__body",
  "content": "index-module-scss-module__jymB6W__content",
  "icon": "index-module-scss-module__jymB6W__icon",
  "premium": "index-module-scss-module__jymB6W__premium",
});
